import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["id", "handleClose", "position", "open", "title", "children", "footerButtons", "role", "maxWidth", "footerButtonBorderRadius", "modalContentRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { _TitleContainer, _Title, _Modal, _ModalBody, _ModalFooter, _IconButton } from "./styles";
import IconClose from "../../icons/CloseOutlineIcon";
import { useId } from "../../hooks";
import { Typography } from "../Typography";
var ModalTitle = function ModalTitle(_ref) {
  var id = _ref.id,
    title = _ref.title,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(_TitleContainer, null, /*#__PURE__*/React.createElement(_Title, {
    variant: "h5",
    component: "h2",
    id: id
  }, title), /*#__PURE__*/React.createElement(_IconButton, {
    "aria-label": "close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(IconClose, null)));
};
var ModalContent = function ModalContent(_ref2) {
  var modalContentRef = _ref2.modalContentRef,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(_ModalBody, {
    ref: modalContentRef
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, children));
};
var usePositionTopStyles = makeStyles(function (theme) {
  return {
    scrollPaper: {
      paddingTop: theme.spacing(2),
      alignItems: 'baseline'
    }
  };
});
export function Modal(_ref3) {
  var id = _ref3.id,
    handleClose = _ref3.handleClose,
    position = _ref3.position,
    open = _ref3.open,
    title = _ref3.title,
    children = _ref3.children,
    ButtonsComponent = _ref3.footerButtons,
    role = _ref3.role,
    maxWidth = _ref3.maxWidth,
    footerButtonBorderRadius = _ref3.footerButtonBorderRadius,
    modalContentRef = _ref3.modalContentRef,
    props = _objectWithoutProperties(_ref3, _excluded);
  var genId = useId();
  var modalId = id || genId;
  var onClose = useCallback(function (event, reason) {
    if (handleClose) {
      handleClose(event, reason);
    }
  }, [handleClose]);
  var positionTopStyles = usePositionTopStyles();
  var classes = position === 'top' ? positionTopStyles : {};
  return /*#__PURE__*/React.createElement(_Modal, _extends({}, props, {
    "aria-labelledby": "".concat(modalId, "-dialog-title"),
    classes: classes,
    id: id,
    onClose: onClose,
    open: open,
    role: role,
    maxWidth: maxWidth
  }), /*#__PURE__*/React.createElement(ModalTitle, {
    id: "".concat(modalId, "-dialog-title"),
    title: title,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(ModalContent, {
    modalContentRef: modalContentRef
  }, children), ButtonsComponent && /*#__PURE__*/React.createElement(_ModalFooter, {
    footerButtonBorderRadius: footerButtonBorderRadius
  }, /*#__PURE__*/React.createElement(ButtonsComponent, null)));
}
Modal.defaultProps = {
  maxWidth: 'sm',
  fullWidth: false
};